function scrollTo() {
    return {
        restrict: 'A',
        scope: {
            scrollTo: "@"
        },
        link: function(scope, $elm, attr) {

            $elm.on('click', function(e) {
                e.preventDefault();
                $('html,body').animate({scrollTop: $(attr.scrollToItem).offset().top }, "slow");
            });
        }
    };
}

export default scrollTo;


// WEBPACK FOOTER //
// ./src/app/directives/scroll-to-directive.js